import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import PublicLayout from "@/components/PublicLayout";
import Home from "@/pages/Home";
import ResultPage from "@/pages/ResultPage";
import ScoreCardPage from "@/pages/ScoreCardPage";
import NoticeListPage from "@/pages/NoticeListPage";
import StaticPage from "@/pages/StaticPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import ProtectedRoute from "@/components/ProtectedRoute";

function App() {
  useEffect(() => {
    document.title = "Home | Bihar Technical Service Commission";
  }, []);

  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<StaticPage slug="about" />} />
              <Route path="/important-notices" element={<NoticeListPage category="important_notices" title="Important Notices" />} />
              <Route path="/latest-update" element={<NoticeListPage category="latest_update" title="Latest Update" />} />
              <Route path="/notice-board" element={<NoticeListPage category="notice_board" title="Notice Board" />} />
              <Route path="/act-and-rules" element={<StaticPage slug="act-and-rules" />} />
              <Route path="/budgets" element={<StaticPage slug="budgets" />} />
              <Route path="/recruitments" element={<StaticPage slug="recruitments" />} />
              <Route path="/syllabus" element={<StaticPage slug="syllabus" />} />
              <Route path="/objection-portal" element={<StaticPage slug="objection-portal" />} />
              <Route path="/admit-card" element={<StaticPage slug="admit-card" />} />
              <Route path="/score-card" element={<ScoreCardPage />} />
              <Route path="/result" element={<ResultPage />} />
              <Route path="/tender" element={<StaticPage slug="tender" />} />
            </Route>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
